import { useState } from 'react'

export const CURSO_MIN_YEAR = 2000
export const CURSO_MAX_YEAR = 2100

const emptyValues = {
  anio: new Date().getFullYear(),
  nombre: '',
  nivel: '',
  seccion: '',
  activo: true,
}

const inputClass = 'mt-2 w-full rounded-xl border border-border bg-surface px-4 py-3 text-text-primary outline-none transition placeholder:text-text-secondary/60 focus:border-secondary focus:ring-4 focus:ring-secondary/15'
const labelClass = 'block text-sm font-medium text-text-primary'

export default function CursoForm({ initialValues, onSubmit, onCancel, submitLabel }) {
  const [values, setValues] = useState({ ...emptyValues, ...initialValues })
  const [errors, setErrors] = useState({})
  const [saving, setSaving] = useState(false)
  const [submitError, setSubmitError] = useState('')

  function update(field, value) {
    setValues((current) => ({ ...current, [field]: value }))
    if (errors[field]) setErrors((current) => ({ ...current, [field]: '' }))
  }

  function validate() {
    const nextErrors = {}
    const year = Number(values.anio)
    if (!Number.isInteger(year) || year < CURSO_MIN_YEAR || year > CURSO_MAX_YEAR) {
      nextErrors.anio = `Ingresa un año entre ${CURSO_MIN_YEAR} y ${CURSO_MAX_YEAR}.`
    }
    if (!values.nombre.trim()) nextErrors.nombre = 'El nombre es obligatorio.'
    setErrors(nextErrors)
    return Object.keys(nextErrors).length === 0
  }

  async function handleSubmit(event) {
    event.preventDefault()
    setSubmitError('')
    if (!validate() || saving) return
    setSaving(true)
    try {
      const result = await onSubmit({
        anio: Number(values.anio),
        nombre: values.nombre.trim(),
        nivel: values.nivel.trim(),
        seccion: values.seccion.trim(),
        activo: Boolean(values.activo),
      })
      if (result === false) setSaving(false)
    } catch (error) {
      setSubmitError(error.message)
      setSaving(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} noValidate className="space-y-6">
      {submitError && <div className="rounded-xl border border-danger/25 bg-danger/5 p-4 text-sm text-danger" role="alert">{submitError}</div>}
      <section className="rounded-2xl border border-border bg-surface p-5 shadow-sm sm:p-6">
        <div className="border-b border-border pb-4"><h2 className="text-lg font-semibold">Información del curso</h2><p className="mt-1 text-sm text-text-secondary">Datos de identificación dentro del establecimiento.</p></div>
        <div className="mt-5 grid gap-5 sm:grid-cols-2">
          <label className={labelClass}>Año <span className="text-danger">*</span><input type="number" min={CURSO_MIN_YEAR} max={CURSO_MAX_YEAR} step="1" value={values.anio} onChange={(event) => update('anio', event.target.value)} className={inputClass} aria-invalid={Boolean(errors.anio)} />{errors.anio && <span className="mt-1.5 block text-xs text-danger">{errors.anio}</span>}</label>
          <label className={labelClass}>Nombre <span className="text-danger">*</span><input value={values.nombre} onChange={(event) => update('nombre', event.target.value)} placeholder="1° Básico A" className={inputClass} aria-invalid={Boolean(errors.nombre)} />{errors.nombre && <span className="mt-1.5 block text-xs text-danger">{errors.nombre}</span>}</label>
          <label className={labelClass}>Nivel<input value={values.nivel} onChange={(event) => update('nivel', event.target.value)} placeholder="Prebásica, Básica o Media" className={inputClass} /></label>
          <label className={labelClass}>Sección<input value={values.seccion} onChange={(event) => update('seccion', event.target.value)} placeholder="A, B o C" className={inputClass} /></label>
          <label className={labelClass}>Estado<select value={values.activo ? 'activo' : 'inactivo'} onChange={(event) => update('activo', event.target.value === 'activo')} className={inputClass}><option value="activo">Activo</option><option value="inactivo">Inactivo</option></select></label>
        </div>
      </section>
      <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <button type="button" onClick={onCancel} disabled={saving} className="rounded-xl border border-border bg-surface px-5 py-3 font-semibold text-text-primary transition hover:border-secondary hover:text-primary disabled:opacity-60">Cancelar</button>
        <button type="submit" disabled={saving} className="rounded-xl bg-primary px-5 py-3 font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60">{saving ? 'Guardando…' : submitLabel}</button>
      </div>
    </form>
  )
}
